

(function () {

    'use strict';
    angular.module('app')
        .service('wowTrackingService',
            function () {
                this.trackPage = function (email, firstName, lastName, title, url) {

                    _wow.push(['setEmailAddress', email]);
                    _wow.push(['setName', firstName, lastName]);
                    _wow.push(['trackPageView', title, url]);
                };
            });

})();